import ExternalEvents from "./ExternalEvents";
import animateValue, { updateHeight } from "../animateValue";
import { addKeydownEventListener } from "../keyboard";
import { setAriaExapndedAttribute, setInertAttribute, setExpendableAttributes } from "../accessibility";
import { mediaMin } from "../breakpoints";
import { debounce } from "../performance";

export default class Expandable extends ExternalEvents {
    constructor(el, animationDuration = 250) {
        super(["open", "close"]);
        this.el = el;
        this.toggle = this.el.querySelector(".expandable__opener");
        this.content = this.el.querySelector(".expandable__content");
        this.openedByDefault = el.classList.contains("expandable--expanded");
        this.isOpened = this.openedByDefault;
        this.animationDuration = animationDuration;
        const isDisabled = this.isDisabled();

        if (this.toggle || this.content)
            setExpendableAttributes(
                this.toggle,
                this.content,
                isDisabled ? true : this.isOpened,
                !isDisabled ? this.isOpened : undefined
            );
    }

    isDisabled() {
        return (
            (mediaMin("md") && this.el.classList.contains("expandable--disable-md")) ||
            (mediaMin("lg") && this.el.classList.contains("expandable--disable-lg"))
        );
    }

    toggleExpandable(open = null, e) {
        if (this.isDisabled()) return;

        this.isOpened = open ?? !this.isOpened;

        const actionType = this.isOpened ? "add" : "remove";
        const maxHeight = !this.isOpened ? 0 : this.content.scrollHeight;

        animateValue(
            this.content,
            updateHeight,
            this.content.offsetHeight,
            maxHeight,
            this.animationDuration
        );

        this.runExternalEventHandlers(this.isOpened ? "open" : "close", e);

        if (this.openedByDefault) this.el.classList.remove("expandable--expanded");

        this.el.classList[actionType]("expandable--active");

        setAriaExapndedAttribute(this.toggle, this.isOpened);
        setInertAttribute(this.content, this.isOpened);
    }

    handleToggleClick(e) {
        this.toggleExpandable(null, e);
    }

    handleEscapeEvent() {
        if (this.isOpened) this.toggleExpandable(false);
    }

    handleResizeEvent() {
        const isDisabled = this.isDisabled();

        setAriaExapndedAttribute(this.toggle, isDisabled ? true : this.isOpened);
        setInertAttribute(this.content, isDisabled ? true : this.isOpened);
    }

    init() {
        if (!this.toggle || !this.content) return;

        this.toggle.addEventListener("click", this.handleToggleClick.bind(this));
        addKeydownEventListener(this.el, { Escape: [this.handleEscapeEvent.bind(this)] });
        window.addEventListener("resize", debounce(this.handleResizeEvent.bind(this), 1000));
    }
}
